export const bicCountryMismatchError = 'BIC ei vastaa tilinumeroa';
const normalize = (value) => value.replace(/\s/g, '').toUpperCase();
const BIC_COUNTRY_CODE_LENGTH = 6;
/**
 * Compares the country code of an account number (IBAN characters 1-2) to the
 * country code of a BIC (characters 5-6). Neither the existence of the BIC nor
 * the format of either value is validated.
 *
 * Finnish account numbers always match, because the BIC is derived from the
 * account number instead of being given by the user. A missing or too short BIC
 * always matches, because the format validations report those.
 */
export const bicCountryMatchesAccountNumber = (accountNumber, bic) => {
    const normalizedAccountNumber = normalize(accountNumber);
    const normalizedBic = normalize(bic ?? '');
    if (normalizedAccountNumber.startsWith('FI')) {
        return true;
    }
    if (normalizedAccountNumber.length < 2 ||
        normalizedBic.length < BIC_COUNTRY_CODE_LENGTH) {
        return true;
    }
    return normalizedAccountNumber.slice(0, 2) === normalizedBic.slice(4, 6);
};
//# sourceMappingURL=bic-country.js.map